module.exports = __webpack_public_path__ + "img/40_69_007_280.881688b2.jpg";